import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device';
import TableWithContainer from "utils/Table/TableWithContainer";
import { Help, ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { Typography, IconButton } from "@material-ui/core";
import Popover from '@material-ui/core/Popover';

export default function Comparison(props) {
    const device = React.useContext(DeviceContext);
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent2 = new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    
    const [data, setData] = React.useState([
        ['Total Quotes', '', '', '', '', ''],
        ['Quick', '', '', '', '', ''],
        ['Custom', '', '', '', '', ''],
        ['CRC', '', '', '', '', ''],
        ['Agency', '', '', '', '', ''],
        ['Total Policies', '', '', '', '', ''],
        ['Online', '', '', '', '', ''],
        ['CRC', '', '', '', '', ''],
        ['Combo', '', '', '', '', ''],
        ['Agency', '', '', '', '', ''],
        ['Total Premium', '', '', '', '', ''],
        ['Online', '', '', '', '', ''],
        ['CRC', '', '', '', '', ''],
        ['Combo', '', '', '', '', ''],
        ['Agency', '', '', '', '', ''],
        ['Average Premium', '', '', '', '', ''],
        ['Online', '', '', '', '', ''],
        ['CRC', '', '', '', '', ''],
        ['Combo', '', '', '', '', ''],
        ['Agency', '', '', '', '', '']
    ]);
    const [loading, setLoading] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [quotes, setQuotes] = React.useState([]);
    const [policies, setPolicies] = React.useState([]);
    const [premium, setPremium] = React.useState([]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const headers = [[
        props.city ? props.city.toUpperCase() :
            props.states.length > 1 ? "ALL STATES" :
                props.states[0] === 'MI' ? 'MICHIGAN' :
                    props.states[0] === 'NJ' ? 'NEW JERSEY' :
                        props.states[0] === 'PA' ? 'PENNSYLVANIA' : '',
        'Range A',
        (<>
            <span>Bind %</span>
            <IconButton
                variant="contained" size="small" component="span"
                style={{ color: "#25b7d3", maxHeight: "10px", position: "absolute" }}
                onClick={handleClick}
            >
                <Help />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Typography>Percentage of policies bound to-date, based on the specific quotes from each applicable time period.</Typography>
            </Popover>
        </>),
        'Range B',
        (<>
            <span>Bind %</span>
            <IconButton
                variant="contained" size="small" component="span"
                style={{ color: "#25b7d3", maxHeight: "10px", position: "absolute" }}
                onClick={handleClick}
            >
                <Help />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Typography>Percentage of policies bound to-date, based on the specific quotes from each applicable time period.</Typography>
            </Popover>
        </>),
        'Change'
    ]];

    const GetData = async (type) => {
        const response = await CallAPI("POST", `/Comparison/Get${type}`, {
            startDateA: props.startDateA,
            endDateA: props.endDateA,
            startDateB: props.startDateB,
            endDateB: props.endDateB,
            states: props.states,
            city: props.city
        });

        if (response) {
            if (type == 'Quotes') {
                const formattedResponse = response.map((row) => [
                    row.row,
                    integer.format(row.rangeA),
                    percent.format(row.bindPercentageA / 100),
                    integer.format(row.rangeB),
                    percent.format(row.bindPercentageB / 100),
                    {
                        style: { color: row.change > 0 ? "green" : "red" },
                        text: <>
                            {row.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                            {row.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                            {percent2.format(row.change / 100)}
                        </>
                    }
                ]);
                setQuotes(formattedResponse);
            } else if (type == 'Policies') {
                const formattedResponse = response.map((row) => [
                    row.row,
                    integer.format(row.rangeA), '',
                    integer.format(row.rangeB), '',
                    {
                        style: { color: row.change > 0 ? "green" : "red" },
                        text: <>
                            {row.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                            {row.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                            {percent2.format(row.change / 100)}
                        </>
                    }
                ]);
                setPolicies(formattedResponse);
            } else if (type == 'Premium') {
                const formattedResponse = response.map((row) => [
                    row.row,
                    currency.format(row.rangeA), '',
                    currency.format(row.rangeB), '',
                    {
                        style: { color: row.change > 0 ? "green" : "red" },
                        text: <>
                            {row.change > 0 && <ArrowUpward style={{ marginBottom: "-7px" }} />}
                            {row.change < 0 && <ArrowDownward style={{ marginBottom: "-7px" }} />}
                            {percent2.format(row.change / 100)}
                        </>
                    }
                ]);
                setPremium(formattedResponse);
            }
        }
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData('Quotes');
            GetData('Policies');
            GetData('Premium');
            setLoading(true);
        }
    }, [props.call]);

    useEffect(() => {
        if (loading && quotes?.length > 0 && policies?.length > 0 && premium?.length > 0) {
            setData([...quotes, ...policies, ...premium]);
            setLoading(false);
        }
    }, [quotes, policies, premium]);

    return (
        <div>
            <TableWithContainer
                loading={loading}
                fixedColumns={1}
                style={{
                    Grid: {
                        Item: {
                            padding: device.isMobile ? "1.3em" : "2.5em",
                            margin: device.isMobile ? "0" : "2.5em"
                        }
                    },
                    Table: {
                        Container: { marginTop: "0", maxHeight: "unset" },
                        TableSX: { minWidth: '605px', tableLayout: 'fixed' }, // fixed = all columns same width
                        Header: { textAlign: "left" },
                        Body: { textAlign: "left" }
                    }
                }}
                headers={headers}
                rows={data}
            />
        </div>
    );
}
